import "./Contact.module.css";
import UstMenu from "@/reusable_sections/Header";
import TalepVeTeklifFormu from "./sections/TalepVeTeklifFormu";
import GetDirections from "./sections/GetDirections";
import Contact from "./sections/Contact";
import CorporateFooter from "@/reusable_sections/Footer";
export default function ContactPage() {
  return <div>
      <UstMenu />
      <TalepVeTeklifFormu />
      <Contact />
      <GetDirections />
      <CorporateFooter />
    </div>;
}